function CustomPageTransition() {
	this.pageTransition = document.querySelector('.page-transition');
	this.logo = this.pageTransition.querySelector('.logo');
	this.fullScreen = document.querySelector('.fullscreen-menu');
	this.header = document.querySelector('header');
}

CustomPageTransition.prototype.leave = function(doneCallback) {
	const that = this;
	TweenMax.to(this.pageTransition , 1, {
		y: '0%',
		ease: Expo.easeInOut,
		onComplete: function () {
			TweenMax.to(that.fullScreen, 0, {
				y: '110%'
			});
			that.header.classList.remove('header-compact' ,'menu-open');
			doneCallback();
		}
	});
};

CustomPageTransition.prototype.enter = function(doneCallback) {
	const that = this;
	TweenMax.to(this.pageTransition , 0.9, {
		opacity: 0,
		ease: Expo.easeInOut,
		onComplete: function () {
			TweenMax.to(that.pageTransition , 0, {
				y: '110%',
				opacity: 1
			});
			that.logo.style.display = 'none';
			doneCallback();
		}
	});
};

